import { Paths } from "./Constants/paths";
import { UserRole } from "./Constants/userRole";

export type ROLE_CONFIG_TYPE = {
  [key: string]: {
    allowedRoles: string[];
  };
};

const ROLE_CONFIG: ROLE_CONFIG_TYPE = {
  [Paths.Dashboard]: {
    allowedRoles: [
      UserRole.ADMIN,
      UserRole.SUPERADMIN,
      UserRole.TEACHER,
      UserRole.USER,
    ],
  },

  [Paths.StudentList]: {
    allowedRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },

  [Paths.StudentAdmission]: {
    allowedRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },

  [Paths.StudentDetails]: {
    allowedRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },

  [Paths.ParentsDetail]: {
    allowedRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },

  [Paths.RegisterParent]: {
    allowedRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },

  [Paths.ParentsList]: {
    allowedRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },

  [Paths.RegisterTeachers]: {
    allowedRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },

  [Paths.TeachersList]: {
    allowedRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },

  [Paths.TeacherDetail]: {
    allowedRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },

  [Paths.Subject]: {
    allowedRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },

  [Paths.Branch]: {
    allowedRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },

  [Paths.Block]: {
    allowedRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },

  [Paths.Class]: {
    allowedRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },

  [Paths.Transport]: {
    allowedRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },

  [Paths.Notification]: {
    allowedRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },

  [Paths.AddResult]: {
    allowedRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },

  [Paths.ResultDetails]: {
    allowedRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },

  [Paths.SchoolPrices]: {
    allowedRoles: [UserRole.ADMIN, UserRole.SUPERADMIN],
  },
};

export const isUserRoleValidForNavigation = ({
  path,
  userRole,
}: {
  path: string | undefined;
  userRole: string;
}) => {
  // because some path may have query params.
  const sanitizedPath = (path || "").replace(/\?.*$/, "");

  return ROLE_CONFIG[
    sanitizedPath as keyof typeof ROLE_CONFIG
  ]?.allowedRoles.includes(userRole);
};
